import { lazy } from 'react';

import { PageLayout } from '../layouts';

import type { RouteObject } from 'react-router-dom';

const Home = lazy(() =>
  import('@/pages/home-page').then((module) => ({
    default: module.Page,
  })),
);

const NewAd = lazy(() =>
  import('@/pages/new-ad-page').then((module) => ({
    default: module.Page,
  })),
);

const CreateTask = lazy(() =>
  import('@/pages/create-task-page').then((module) => ({
    default: module.Page,
  })),
);

const SuccessCreatedOrder = lazy(() =>
  import('@/pages/success-created-order').then((module) => ({
    default: module.Page,
  })),
);

const SuccessPublishedOrder = lazy(() =>
  import('@/pages/success-published-order').then((module) => ({
    default: module.Page,
  })),
);

const CreateVacancy = lazy(() =>
  import('@/pages/create-vacancy-page').then((module) => ({
    default: module.Page,
  })),
);

const CreateAd = lazy(() =>
  import('@/pages/create-ad-page').then((module) => ({
    default: module.Page,
  })),
);

const Orders = lazy(() =>
  import('@/pages/orders-overview').then((module) => ({
    default: module.Page,
  })),
);

const Chat = lazy(() =>
  import('@/pages/chat-page').then((module) => ({
    default: module.Page,
  })),
);

const Task = lazy(() =>
  import('@/pages/task-overview').then((module) => ({
    default: module.Page,
  })),
);

const SuitableSpecialists = lazy(() =>
  import('@/pages/suitable-specialists-overview').then((module) => ({
    default: module.Page,
  })),
);

const Vacancy = lazy(() =>
  import('@/pages/vacancy-overview').then((module) => ({
    default: module.Page,
  })),
);

const Ad = lazy(() =>
  import('@/pages/ad-overview').then((module) => ({
    default: module.Page,
  })),
);

const Profile = lazy(() =>
  import('@/pages/profile-overview').then((module) => ({
    default: module.Page,
  })),
);

const Categories = lazy(() =>
  import('@/pages/categories-overview').then((module) => ({
    default: module.Page,
  })),
);

const Subcategory = lazy(() =>
  import('@/pages/subcategory-overview').then((module) => ({
    default: module.Page,
  })),
);

const FilterOrders = lazy(() =>
  import('@/pages/filter-orders-page').then((module) => ({
    default: module.Page,
  })),
);

const Specialists = lazy(() =>
  import('@/pages/specialists-overview').then((module) => ({
    default: module.Page,
  })),
);

const Specialist = lazy(() =>
  import('@/pages/specialist-overview').then((module) => ({
    default: module.Page,
  })),
);

const OfferOrder = lazy(() =>
  import('@/pages/offer-order-page').then((module) => ({
    default: module.Page,
  })),
);

const PersonalInformation = lazy(() =>
  import('@/pages/personal-info-page').then((module) => ({
    default: module.Page,
  })),
);

const SecuritySettings = lazy(() =>
  import('@/pages/security-settings-page').then((module) => ({
    default: module.Page,
  })),
);

const MessageTemplates = lazy(() =>
  import('@/pages/message-templates-page').then((module) => ({
    default: module.Page,
  })),
);

const Favorite = lazy(() =>
  import('@/pages/favorite-overview').then((module) => ({
    default: module.Page,
  })),
);

const Reviews = lazy(() =>
  import('@/pages/reviews-overview').then((module) => ({
    default: module.Page,
  })),
);

export const paths: RouteObject[] = [
  {
    path: '/',
    element: <PageLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'new-ad',
        element: <NewAd />,
      },
      {
        path: 'orders',
        element: <Orders />,
      },
      {
        path: 'profile',
        element: <Profile />,
      },
    ],
  },
  {
    path: '/',
    element: <PageLayout bottomBar={false} />,
    children: [
      {
        path: 'categories',
        children: [
          {
            index: true,
            element: <Categories />,
          },
          {
            path: ':id',
            children: [
              {
                index: true,
                element: <Subcategory />,
              },
              {
                path: 'filter',
                element: <FilterOrders />,
              },
            ],
          },
        ],
      },
      {
        path: 'orders',
        children: [
          {
            path: 'task/:id',
            children: [
              {
                index: true,
                element: <Task />,
              },
              {
                path: 'suitable-specialists/:categoryId',
                element: <SuitableSpecialists />,
              },
              {
                path: 'chat/:id/:type',
                element: <Chat />,
              },
            ],
          },
          {
            path: 'vacancy/:id',
            element: <Vacancy />,
          },
          {
            path: 'ad/:id',
            element: <Ad />,
          },
        ],
      },
      // {
      //   path: 'new-ad/task',
      //   element: <CreateTask />,
      // },
      // {
      //   path: 'new-ad/vacancy',
      //   element: <CreateVacancy />,
      // },
      // {
      //   path: 'new-ad/ad',
      //   element: <CreateAd />,
      // },
      {
        path: 'new-ad',
        children: [
          {
            path: 'task',
            children: [
              {
                index: true,
                element: <CreateTask />,
              },
              {
                path: 'success-created/:type/:id',
                element: <SuccessCreatedOrder />,
              },
            ],
          },
          {
            path: 'vacancy',
            children: [
              {
                index: true,
                element: <CreateVacancy />,
              },
              {
                path: 'success-created/:type/:id',
                element: <SuccessCreatedOrder />,
              },
            ],
          },
          {
            path: 'ad',
            children: [
              {
                index: true,
                element: <CreateAd />,
              },
              {
                path: 'success-created/:type',
                element: <SuccessCreatedOrder />,
              },
            ],
          },
          {
            path: 'success-published',
            element: <SuccessPublishedOrder />,
          },
        ],
      },
      {
        path: 'profile',
        children: [
          {
            path: 'specialists',
            children: [
              {
                index: true,
                element: <Specialists />,
              },
              {
                path: ':id',
                children: [
                  {
                    index: true,
                    element: <Specialist />,
                  },
                  {
                    path: 'offer',
                    element: <OfferOrder />,
                  },
                ],
              },
            ],
          },
          {
            path: 'personal-information',
            element: <PersonalInformation />,
          },
          {
            path: 'security-settings',
            element: <SecuritySettings />,
          },
          {
            path: 'message-templates',
            element: <MessageTemplates />,
          },
          {
            path: 'favorite',
            element: <Favorite />,
          },
          {
            path: 'reviews',
            element: <Reviews />,
          },
        ],
      },
    ],
  },
];
